import arabicCategoryNames from "../statics/arabicCategoryNames";
import localization from "../statics/localization";
const labels = {
  "Home": "الرئيسية",
  "Featured": "المحتوى المميز",
  "Continue Watching": "متابعة المشاهدة",
  "Recently Watched": "شوهد مؤخرًا",
  "Recently Watched Channels": "القنوات المشاهدة مؤخرًا",
  "My List": "قائمتي",
  "All Channels": "جميع القنوات",
  "Kids Channels": "قنوات الأطفال",
  "Coming Soon": "قريبًا",
  "Top 10": "أفضل 10",
  "Movies": "الأفلام",
  "Series": "المسلسلات",
  "Kids": "الأطفال",
  "Documentaries": "الأفلام الوثائقية",
  "Rental": "الاستئجار",
  "RENTAL": "الاستئجار",
  "On Demand": "حسب الطلب",
  "Catch Up": "إعادة المشاهدة",
  "İzlemeye Devam Et": "متابعة المشاهدة",
  "Ana Sayfa": "الرئيسية",
  "Öne Çıkanlar": "المحتوى المميز",
  "Çok Yakında": "قريبًا",
  "En İyi 10": "أفضل 10"
};
// Translate application/navigation labels, never content titles or category identities.
export const catalogLabel = (value, type) => localization.getLanguage() === "arb"
 ? (type === "REPLAYS" ? "متابعة المشاهدة" : arabicCategoryNames[value] || labels[value] || value) : value;
